module.exports = __webpack_public_path__ + "img/mission-digital-twin-small.cc4ef6f3.svg";